import React, { useState, useEffect } from "react";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { useNavigate, useParams, Link } from "react-router-dom";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const getToday = () => {
  const date = new Date();

  const year = date.getFullYear();

  const month = String(date.getMonth() + 1).padStart(2, "0");

  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

function HodPerfomanceAllocationList() {
  const navigate = useNavigate();
  const [performance, setPerformance] = useState([]);
  const [loading, setLoading] = useState(false);

  const currentdate = new Date();

  const currentYear = currentdate.getFullYear();
  const currentMonth = currentdate.getMonth() + 1;
  const currentday = currentdate.getDate();

  const [filters, setFilters] = useState({
    search: "",
    date: getToday(),
    day: currentday,
    yearName: currentYear,
    monthName: currentMonth,
    frequency: "Monthly",
    quarter: [],
    status: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [date, setDate] = useState(getToday());

  const SERVER_URL = process.env.REACT_APP_API_URL;
  const BASE_URL = process.env.REACT_APP_APP_URL;

  const token = JSON.parse(localStorage.getItem("key"));

  const tokenDecoded = jwt_decode(token.value);
  // console.log(tokenDecoded, "tokenDecoded========");
  const systemRole = tokenDecoded.systemRole ?? "";
  const userID = tokenDecoded.userId ?? "";

  useEffect(() => {
    loadHodAllocations();
  }, [
    filters.date,
    currentPage,
    recordsPerPage,
    filters.day,
    filters.search,
    filters.monthName,
    filters.yearName,
    filters.frequency,
    filters.quarter,
  ]);

  const loadHodAllocations = async () => {
    try {
      setLoading(true);

      const requestData = {
        role: systemRole,
        user_id: userID,
        page: currentPage,
        pageSize: recordsPerPage,
        date: date,
        frequency: filters.frequency,
        quarter: filters.quarter,
        day: filters.day,
        month: filters.monthName,
        year: filters.yearName,
        search: filters.search || "",
      };

      const apiUrl = `${SERVER_URL}api/Performance/hod/all`;

      console.log("REQUEST HOD PERFORMANCE API:", apiUrl);
      console.log("REQUEST BODY:", requestData);

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.value}`,
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      console.log(result, "HOD Performance===========");

      setPerformance(result.data?.data || []);
      setTotalRecords(Number(result.total?.data || 0));
    } catch (error) {
      console.error("HOD Performance loading error:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleDateChange = (date) => {
    if (!date) {
      setFilters((prev) => ({
        ...prev,
        date: "",
      }));
      return;
    }

    // Store date as YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;

    setFilters((prev) => ({
      ...prev,
      date: formattedDate,
    }));
  };
  const clearFilters = () => {
    setFilters({
      search: "",
      date: getToday(),
      day: currentday,
      yearName: currentYear,
      monthName: currentMonth,
      frequency: "Monthly",
      quarter: "",
      status: "",
    });

    setCurrentPage(1);
  };

  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const startIndex =
    totalRecords === 0 ? 0 : (currentPage - 1) * recordsPerPage;

  const endIndex = Math.min(currentPage * recordsPerPage, totalRecords);
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      setCurrentPage(page);
    }
  };
  const getPageNumbers = () => {
    const pages = [];

    // No pages
    if (totalPages <= 0) {
      return pages;
    }

    // 1 - 5 pages
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    // Current page near beginning
    if (currentPage <= 3) {
      pages.push(1, 2, 3, 4, "...", totalPages);

      return pages;
    }

    // Current page near end
    if (currentPage >= totalPages - 2) {
      pages.push(
        1,
        "...",
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      );

      return pages;
    }

    // Current page in middle
    pages.push(
      1,
      "...",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "...",
      totalPages,
    );

    return pages;
  };

  return (
    <>
      <div className="page-header">
        <h3>HOD Performance List</h3>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <a href="/dashboard">Dashboard </a>
          </li>
          <li className="current">
            <span>/</span> Hod Performance
          </li>
        </ul>
      </div>
      {/* Search */}

      <div className="row_bg">
        <div className="dash_white_box2 mb20 p20">
          <div className="row mb10">
            <div className="col-lg-3 col-md-6 pr07">
              <label className="form-label">Search</label>
              <input
                type="text"
                className="form-control"
                name="search"
                placeholder="Employee, manager, department, task..."
                value={filters.search}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    search: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-lg-3 col-md-6 pl07 pr07">
              <label className="form-label">Frequency</label>
              <select
                className="form-select"
                name="frequency"
                value={filters.frequency}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    frequency: e.target.value,
                  })
                }
              >
                <option value="Daily">Daily</option>
                <option value="Monthly">Monthly</option>
                <option value="Quarterly">Quarterly</option>
                <option value="Yearly">Yearly</option>
              </select>
            </div>
            {filters.frequency === "Monthly" && (
              <div className="col-lg-3 col-md-6 pl07 pr07">
                <label className="form-label">Month</label>
                <select
                  className="form-control"
                  value={filters.monthName}
                  name="monthName"
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      monthName: e.target.value,
                    })
                  }
                >
                  <option value="">--Select Month--</option>
                  <option value="1">January</option>
                  <option value="2">February</option>
                  <option value="3">March</option>
                  <option value="4">April</option>
                  <option value="5">May</option>
                  <option value="6">June</option>
                  <option value="7">July</option>
                  <option value="8">August</option>
                  <option value="9">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                </select>
              </div>
            )}
            {filters.frequency === "Daily" && (
              <div className="col-lg-3 col-md-6 pr07">
                <label className="form-label">Date</label>

                <DatePicker
                  selected={
                    filters.date ? new Date(`${filters.date}T00:00:00`) : null
                  }
                  onChange={handleDateChange}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="DD-MM-YYYY"
                  className="form-control"
                  name="date"
                  autoComplete="off"
                />
              </div>
            )}
            {filters.frequency === "Quarterly" && (
              <div className="col-lg-3 col-md-6 pl07 pr07">
                <label className="form-label">Quarter</label>
                <Select
                  options={[
                    {
                      value: "Q1",
                      label: "Q1 (April-June)",
                    },
                    {
                      value: "Q2",
                      label: "Q2 (July-September)",
                    },
                    {
                      value: "Q3",
                      label: "Q3 (October-December)",
                    },
                    {
                      value: "Q4",
                      label: "Q4 (January-March)",
                    },
                  ]}
                  value={[
                    { value: "Q1", label: "Q1 (April-June)" },
                    { value: "Q2", label: "Q2 (July-September)" },
                    { value: "Q3", label: "Q3 (October-December)" },
                    { value: "Q4", label: "Q4 (January-March)" },
                  ].filter((option) => filters.quarter?.includes(option.value))}
                  onChange={(selected) => {
                    const quarters = (selected || []).map((item) => item.value);

                    setFilters((prev) => ({
                      ...prev,
                      quarter: quarters,
                    }));
                  }}
                  isMulti
                  isClearable
                  isSearchable
                  closeMenuOnSelect={false}
                  placeholder="Select Quarter"
                  classNamePrefix="quarter-select"
                />
              </div>
            )}
            <div className="col-lg-3 col-md-6 pl07 pr07">
              <label className="form-label">Year</label>
              <select
                className="form-control"
                value={filters.yearName}
                name="yearName"
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    yearName: e.target.value,
                  })
                }
              >
                <option value="">--Select Year--</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
              </select>
            </div>
          </div>
          <div className="row float-end">
            <div className="col-lg-12">
              <label className="d-block mb10 pt07"></label>
              <div className="d-flex gap-2">
                <button
                  className="btn_2 btn-sm btn-info "
                  onClick={clearFilters}
                >
                  Clear Filters
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row mb30">
          <div className="col-md-12">
            <strong>All Hod Performance</strong>

            <span className="float-end">{totalRecords} Records</span>
          </div>

          <div
            className="col-md-12"
            style={{
              width: "100%",
              overflowX: "auto",
              overflowY: "hidden",
            }}
          >
            <table
              className="table_style_1"
              style={{
                minWidth: "1200px",
                whiteSpace: "nowrap",
              }}
            >
              <thead className="table-primary">
                <tr>
                  <th>S.No</th>
                  <th>Employee Name/Code</th>
                  <th>Department Name</th>
                  {/* <th>KPI Score</th>
                  <th>Daily Score</th>
                  <th>Final</th>
                  <th>Rating</th>
                  <th>Status</th> */}
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="4" className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : performance.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No allocation found
                    </td>
                  </tr>
                ) : (
                  performance.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>

                      <td>
                        <strong>
                          {item.employee_name} ({item.emp_code})
                        </strong>
                      </td>
                      <td>
                        <strong>{item.department_name}</strong>
                      </td>
                      {/* <td>
                        <span
                          className={`badge ${
                            item.final_score >= 80
                              ? "bg-success"
                              : item.final_score >= 60
                                ? "bg-warning"
                                : "bg-danger"
                          }`}
                        >
                          {item.kpi_score ? item.kpi_score : "0.00"}%
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            item.final_score >= 80
                              ? "bg-success"
                              : item.final_score >= 60
                                ? "bg-warning"
                                : "bg-danger"
                          }`}
                        >
                          {item.daily_score ? item.daily_score : "0.00"}%
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            item.final_score >= 80
                              ? "bg-success"
                              : item.final_score >= 60
                                ? "bg-warning"
                                : "bg-danger"
                          }`}
                        >
                          {item.final_score ? item.final_score : "0.00"}%
                        </span>
                      </td>
                      <td>{item.manager_rating ? item.manager_rating : "0"}</td>
                      <td>
                        {item.review_status === "Approved" ? (
                          <span className="badge bg-success">Approved</span>
                        ) : item.review_status === "Rejected" ? (
                          <span className="badge bg-danger">Rejected</span>
                        ) : (
                          <span className="badge bg-warning">Pending</span>
                        )}
                      </td> */}

                      <td>
                        <div className="d-flex gap-1">
                          {/* View */}

                          {/* <button
                            className="btn btn-sm btn-info"
                            title="KPI"
                            onClick={() => handleView(item.id)}
                          >
                            KPI
                          </button> */}
                          <Link
                            className="btn btn-sm btn-info"
                            to={`/hod/performance-review/${item.employee_id}/${item.dept_id}/${item.systemRole}`}
                          >
                            View
                          </Link>

                          {/* Edit */}

                          {/* <button
                            className="btn btn-sm btn-warning"
                            title="Edit"
                            onClick={() => handleEdit(item.id)}
                          >
                            ✏️
                          </button> */}
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {/* =================================================
              PAGINATION
          ================================================= */}

          {totalRecords > 0 && (
            <div className="pagination-wrapper">
              {/* Pagination Info */}
              <div className="pagination-info">
                Showing <strong>{startIndex + 1}</strong> to{" "}
                <strong>{endIndex}</strong> of <strong>{totalRecords}</strong>{" "}
                entries
              </div>

              {/* Pagination */}
              <div className="pagination">
                {/* Previous */}
                <button
                  disabled={currentPage === 1 || loading}
                  onClick={() => goToPage(currentPage - 1)}
                >
                  <i className="bi bi-chevron-left">«</i>
                </button>

                {/* Page Numbers */}
                {getPageNumbers().map((page, index) => {
                  if (page === "...") {
                    return (
                      <span key={`dots-${index}`} className="pagination-dots">
                        ...
                      </span>
                    );
                  }

                  return (
                    <button
                      key={page}
                      disabled={loading}
                      className={currentPage === page ? "active" : ""}
                      onClick={() => goToPage(page)}
                    >
                      {page}
                    </button>
                  );
                })}

                {/* Next */}
                <button
                  disabled={currentPage === totalPages || loading}
                  onClick={() => goToPage(currentPage + 1)}
                >
                  <i className="bi bi-chevron-right">»</i>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
export default HodPerfomanceAllocationList;
